import _ from 'underscore';
import React, { useCallback, useContext } from 'react';
import { getImageUrl } from '@culture/common-helpers/cultureUtils';

import { ImageFormatContext } from 'contexts/ImageFormatContext';
import Container from 'components/Container';
import MorphingPromoBlock from 'components/MorphingPromoBlock';
import Section from 'components/Section';
import SizeDependedBlock from 'components/SizeDependedBlock';
import Slider from 'components/sliders/Slider';

import CommonPropTypes from 'utils/propTypes/common';
import { screenBreakpoints } from 'utils/helpers/constants';

const ActualPromoBlocks = ({ promoBlocks }) => {
	const imageFormat = useContext(ImageFormatContext);

	const renderSlider = useCallback(
		(type) => {
			let sliderParams = {
				slidesPerView: 'auto',
				spaceBetween: 12,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				breakpoints: {
					[`${screenBreakpoints.tabletLarge}`]: {
						slidesPerView: 1,
						spaceBetween: 0
					}
				},
				preloadImages: false,
				lazy: true,
				watchSlidesProgress: true,
				watchSlidesVisibility: true
			};

			if (type === 'desktop') {
				sliderParams = {
					...sliderParams,
					loop: true,
					autoplay: { delay: 10000 }
				};
			}

			return (
				<Slider key={type} params={sliderParams} theme="morphing">
					{_(promoBlocks).map((promoBlock) => {
						const imageSrc = getImageUrl(promoBlock.images.sources[type], {
							format: imageFormat
						});

						return (
							<div key={promoBlock._id}>
								<MorphingPromoBlock
									title={promoBlock.title}
									description={promoBlock.text}
									image={imageSrc}
									lazyImage={type === 'mobile'}
									url={promoBlock.url}
								/>
							</div>
						);
					})}
				</Slider>
			);
		},
		[promoBlocks]
	);

	return (
		<Section title="Актуальное" headHide="tabletLarge">
			<Container morphing="tabletLarge">
				<SizeDependedBlock>
					{renderSlider('mobile')}
					{renderSlider('desktop')}
				</SizeDependedBlock>
			</Container>
		</Section>
	);
};

ActualPromoBlocks.propTypes = {
	promoBlocks: CommonPropTypes.entities.isRequired
};

export default ActualPromoBlocks;
